// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1TIK9","colMin":"styles_colMin__20pvE","colCheckbox":"styles_colCheckbox__36xMR"};